import React from "react";
import {ChipLabel} from "./index";

const ApprovalChip = ({contact}) => {
    return (
        <React.Fragment>
            <ChipLabel
                label={contact.pending_for_approval ? 'Pending' : 'Approved'}
                className={`data-access-chip ${contact.pending_for_approval ? 'warning' : 'success'}`}
            />
        </React.Fragment>
    )
}

export default ApprovalChip;